import { formatCurrency } from "@/utils/StringUtils";

/**
 * Extracts first input element inside given html element
 * @param {HTMLElement} el 
 * @returns {HTMLElement|HTMLInputElement}
 */
function queryInputElementInside(el) {
  return el.tagName.toLowerCase() === 'input' ? el : (el.querySelector('input') || el)
}

/**
 * 천 단위 컴마를 자동으로 추가하는 기능을 제공하는 커스텀 디렉티브입니다.
 * 
 * 복잡한 포맷팅의 경우 formatter 대신 v-mask와 같은 라이브러리 사용을 권장
 * Ref: https://github.com/bootstrap-vue/bootstrap-vue/issues/5165#issuecomment-619537580
 */
export default {
  /**
   * @param {HTMLElement} el 
   */
  bind(el) {
    const input = queryInputElementInside(el);
    
    input.addEventListener('input', function(e) {
      // 입력을 했을 때 커서의 위치
      const oldPosition = e.target.selectionStart;
      const oldValue = e.target.value;
      const oldLength = oldValue.length;
      
      // 숫자만 추출 및 포맷팅
      let rawValue = oldValue.replace(/[^\d]/g, '');

      // 연속된 0으로 시작할 경우 모두 제거
      if (rawValue.length > 1 && rawValue.startsWith('0')) {
        rawValue = rawValue.replace(/^0+/, '');
        rawValue === '' && (rawValue = '0');
      }

      const formattedValue = formatCurrency(rawValue);

      // input 엘리먼트 value 업데이트
      e.target.value = formattedValue;
      
      // 커서 위치 계산 및 설정
      const diff = formattedValue.length - oldLength;
      let newPosition = oldPosition + diff;

      // 커서가 제일 앞에 위치해있고, Del 키를 이용해 글자를 지웠을 경우
      // 컴마가 제거될 경우 diff, newPosition이 음수가 될 경우 커서가 텍스트 마지막으로 이동하는 것 방지
      if (oldPosition === 0 && diff < 0 && newPosition < 0) {
        newPosition = 0
      }
      
      e.target.setSelectionRange(newPosition, newPosition);
    });
  }
}